import React, { useCallback, useState, useEffect } from 'react';
import {
  useMsal
  // useIsAuthenticated
} from '@azure/msal-react';
import { styled } from '@mui/material/styles';

import { useSelector } from 'react-redux';
import Drawer from './Drawer';
import { Sidebar } from './sidebar/Sidebar';
import { Topnav } from './topnav/Topnav';
import styles from './Layout.module.scss';
import { Footer } from './footer/Footer';
import AppNotification from '../common/AppNotification/AppNotification';

const drawerWidth = 276;

const Container = styled('div')({
  display: 'flex',
  width: 'auto'
});

const ContentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  display: 'grid',
  width: '100vw',
  minHeight: '100vh',
  grid: `"header" auto
          "content" auto
          "bottombar" auto / auto`,
  position: 'relative',
  zIndex: 0,
  [theme.breakpoints.up('sm')]: {
    transform: `translate3d(0px, 0,0)`,
    grid: `"sidebar header" auto
        "sidebar content" 1fr
        "sidebar footer" auto/ auto 1fr`
  }
}));

const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1',
  gridArea: 'content',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'calc(100vh - 65px)'
  }
}));

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  position: 'fixed',
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));
function Layout({ children, showFooter }) {
  const { instance } = useMsal();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [notification, setNotification] = useState(null);
  const appNotification = useSelector((state) => state.appNotifications?.message);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    document.body.style.overflow = `${isDrawerOpen ? 'auto' : 'hidden'}`;
  };

  const toggleSidebar = (value) => {
    setIsDrawerOpen(value);
  };

  const logout = useCallback(() => {
    localStorage.clear();
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }, [instance]);

  useEffect(() => {
    setNotification(appNotification);
  }, [appNotification]);

  return (
    <Container className={styles.container}>
      <StyledDrawer open={isDrawerOpen} onClose={toggleDrawer} width={drawerWidth} logout={logout} />
      <ContentContainer open={isDrawerOpen}>
        <div id="quick-apply-container" />
        <Topnav onMenuPress={toggleDrawer} drawerOpen={isDrawerOpen} />
        <Sidebar logout={logout} toggleSidebar={toggleSidebar} />
        <Content className={styles.content}>{children}</Content>
        {showFooter ? <Footer /> : null}
      </ContentContainer>
      <AppNotification notification={notification} isDrawerOpen={isDrawerOpen} />
    </Container>
  );
}

export default Layout;
